import type { ReactNode } from "react";

export default function LoadingLabel({ children }: { children: ReactNode }) {
  return <span className="loading-label">{children}<span className="loading-label-dots" aria-hidden="true"><i /><i /><i /></span></span>;
}
